/**
 * Static add-on services catalogue rendered under the subscription tier grid.
 * Until these become first-class Mongo records like the tier products, they
 * live here as a data-only constant so the SubscriptionOffers page stays slim.
 */

export interface AddonItem {
    name: string;
    price: string;
    id: string;
}

export interface AddonCategory {
    category: string;
    items: AddonItem[];
}

export const ADDON_SERVICES: AddonCategory[] = [
    {
        category: "Communication",
        items: [
            { name: "Additional Phone Numbers", price: "$10/month each", id: "phone_number" },
            { name: "International Calling", price: "$50/month", id: "intl_calling" },
            { name: "Premium Transcription", price: "$30/month", id: "transcription" },
            { name: "Video Recording Storage", price: "$20/month (100GB)", id: "video_storage" },
        ],
    },
    {
        category: "AI & Automation",
        items: [
            { name: "Custom AI Agent", price: "$500/month each", id: "ai_agent" },
            { name: "Advanced Analytics Dashboard", price: "$150/month", id: "analytics" },
            { name: "Sentiment Analysis", price: "$100/month", id: "sentiment" },
            { name: "Predictive Analytics", price: "$200/month", id: "predictive" },
        ],
    },
    {
        category: "Process & Compliance",
        items: [
            { name: "Process Mapping Session", price: "$500 one-time", id: "process_map" },
            { name: "Compliance Monitoring", price: "$300/month", id: "compliance" },
            { name: "Audit Trail System", price: "$150/month", id: "audit" },
            { name: "Document Management", price: "$100/month", id: "docs" },
        ],
    },
    {
        category: "Technical",
        items: [
            { name: "Additional Storage", price: "$10/month per 10GB", id: "storage" },
            { name: "Dedicated Server", price: "$200/month", id: "server" },
            { name: "Load Balancing", price: "$150/month", id: "load_balance" },
            { name: "DDoS Protection", price: "$100/month", id: "ddos" },
        ],
    },
    {
        category: "Support",
        items: [
            { name: "24/7 Support", price: "$300/month", id: "support_247" },
            { name: "Dedicated Slack Channel", price: "$150/month", id: "slack" },
            { name: "Weekly Check-ins", price: "$200/month", id: "checkins" },
            { name: "Emergency Response SLA", price: "$500/month", id: "sla" },
        ],
    },
];
